import { Reducer } from 'redux';
import { LayoutState, LayoutTypes } from './types';

const INITIAL_STATE: LayoutState = {
  data: undefined,
  loading: false,
  scroll: false,
};

const reducer: Reducer<LayoutState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case LayoutTypes.LOAD_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case LayoutTypes.LOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        error: undefined,
        data: action.payload.data,
      };
    case LayoutTypes.LOAD_FAILURE:
      return {
        ...state,
        loading: false,
        data: undefined,
        error: action.payload.error,
      };
    case LayoutTypes.SCROLL:
      return {
        ...state,
        scroll: true,
      };
    case LayoutTypes.RESET_SCROLL:
      return {
        ...state,
        scroll: false,
      };
    default:
      return state;
  }
};

export default reducer;
